<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <v-card-title>
        <h4>车辆查询</h4>
      </v-card-title>
      <v-form ref="form">
        <v-layout justify-center class="pa-2">
          <v-flex xs10>
            <l-plate-picker v-model="plate"></l-plate-picker>
          </v-flex>
          <v-flex xs2 class="pt-2">
            <v-btn flat color="primary" @click="goDetails">查询</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </l-layout>
</template>
<script>
import LPlatePicker from '../../components/LPlatePicker'
export default {
  components: {LPlatePicker},
  data () {
    return {
      plate: ''
    }
  },
  methods: {
    async goDetails () {
      try {
        if (!this.$refs.form.validate()) {
          this.$L.alert('error', {message: '车牌号码格式错误!'})
          return
        }
        else if (this.plate === '') {
          this.$L.alert('error', {message: '车牌号码不能为空!'})
          return
        }
        let {items} = await this.$store.dispatch('pass/searchVehicles', {plate: this.plate})
        if (items.length) {
          this.$router.push({
            name: 'VehicleDetailsWX',
            params: {
              plate: items[0].plate,
              vehicle: items[0]
            }
          })
        }
        else {
          throw Error('未找到该车辆')
        }
      }
      catch (e) {
        this.$L.error(e.message)
      }
    }
  }
}
</script>
